/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientDepartmentRequest } from './';
import {
    ClientDepartmentRequestFromJSON,
    ClientDepartmentRequestFromJSONTyped,
    ClientDepartmentRequestToJSON,
} from './';
import type { CompanyIndustryRequest } from './';
import {
    CompanyIndustryRequestFromJSON,
    CompanyIndustryRequestFromJSONTyped,
    CompanyIndustryRequestToJSON,
} from './';
import type { CompanyLegalDetails } from './';
import {
    CompanyLegalDetailsFromJSON,
    CompanyLegalDetailsFromJSONTyped,
    CompanyLegalDetailsToJSON,
} from './';
import type { CompanySizeRequest } from './';
import {
    CompanySizeRequestFromJSON,
    CompanySizeRequestFromJSONTyped,
    CompanySizeRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyDetailsRequest
 */
export interface CompanyDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailsRequest
     */
    companyName?: string;
    /**
     * 
     * @type {CompanySizeRequest}
     * @memberof CompanyDetailsRequest
     */
    companySize?: CompanySizeRequest;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailsRequest
     */
    companyWebsiteUrl?: string;
    /**
     * 
     * @type {ClientDepartmentRequest}
     * @memberof CompanyDetailsRequest
     */
    clientDepartment?: ClientDepartmentRequest;
    /**
     * 
     * @type {CompanyIndustryRequest}
     * @memberof CompanyDetailsRequest
     */
    companyIndustry?: CompanyIndustryRequest;
    /**
     * 
     * @type {CompanyLegalDetails}
     * @memberof CompanyDetailsRequest
     */
    companyLegalDetails?: CompanyLegalDetails;
}

/**
 * Check if a given object implements the CompanyDetailsRequest interface.
 */
export function instanceOfCompanyDetailsRequest(value: object): value is CompanyDetailsRequest {
    return true;
}

export function CompanyDetailsRequestFromJSON(json: any): CompanyDetailsRequest {
    return CompanyDetailsRequestFromJSONTyped(json, false);
}

export function CompanyDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'companySize': json['companySize'] == null ? undefined : CompanySizeRequestFromJSON(json['companySize']),
        'companyWebsiteUrl': json['companyWebsiteUrl'] == null ? undefined : json['companyWebsiteUrl'],
        'clientDepartment': json['clientDepartment'] == null ? undefined : ClientDepartmentRequestFromJSON(json['clientDepartment']),
        'companyIndustry': json['companyIndustry'] == null ? undefined : CompanyIndustryRequestFromJSON(json['companyIndustry']),
        'companyLegalDetails': json['companyLegalDetails'] == null ? undefined : CompanyLegalDetailsFromJSON(json['companyLegalDetails']),
    };
}

export function CompanyDetailsRequestToJSON(value?: CompanyDetailsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyName': value['companyName'],
        'companySize': CompanySizeRequestToJSON(value['companySize']),
        'companyWebsiteUrl': value['companyWebsiteUrl'],
        'clientDepartment': ClientDepartmentRequestToJSON(value['clientDepartment']),
        'companyIndustry': CompanyIndustryRequestToJSON(value['companyIndustry']),
        'companyLegalDetails': CompanyLegalDetailsToJSON(value['companyLegalDetails']),
    };
}

